import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 z-[200] flex items-center justify-center overflow-auto vue-modal-background tw at-update-rate-group",
  style: {
    "z-index": "100"
  }
};
const _hoisted_2 = {
  class: "bg-gray-50 shadow-lg rounded-sm",
  style: {
    "width": "900px",
    "height": "auto",
    "max-width": "100%",
    "max-height": "95vh",
    "overflow-y": "auto"
  }
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  class: "overflow-auto h-full"
};
const _hoisted_5 = {
  class: "flex justify-between py-2"
};
const _hoisted_6 = {
  key: 0,
  class: "font-medium text-base"
};
const _hoisted_7 = {
  class: "py-4 flex flex-row"
};
const _hoisted_8 = {
  class: "email-form-container w-8/12 pr-2"
};
const _hoisted_9 = {
  class: "bg-[rgba(var(--v-theme-error),0.08)] px-8 py-2 flex"
};
const _hoisted_10 = {
  class: "text-error"
};
const _hoisted_11 = {
  class: "bg-yellow-50 px-8 py-2 flex"
};
const _hoisted_12 = {
  class: "flex"
};
const _hoisted_13 = {
  class: "w-6/12 pr-2"
};
const _hoisted_14 = {
  class: "bg-[rgba(var(--v-theme-error),0.08)] px-4 py-1 flex mt-1"
};
const _hoisted_15 = {
  class: "text-error text-sm"
};
const _hoisted_16 = {
  class: "w-6/12 pl-2"
};
const _hoisted_17 = {
  class: "bg-[rgba(var(--v-theme-error),0.08)] px-4 py-1 flex mt-1"
};
const _hoisted_18 = {
  class: "text-error text-sm"
};
const _hoisted_19 = {
  class: "py-2"
};
const _hoisted_20 = {
  class: "pb-2"
};
const _hoisted_21 = {
  class: "rounded mt-2 py-2 cursor-pointer bg-white"
};
const _hoisted_22 = {
  key: 0,
  class: "flex flex-row pt-4"
};
const _hoisted_23 = {
  class: "flex flex-row px-2"
};
const _hoisted_24 = {
  key: 1,
  class: "flex flex-row pt-4"
};
const _hoisted_25 = {
  class: "flex flex-col px-2"
};
const _hoisted_26 = {
  class: "py-1 px-1",
  "data-cy": "without-payment-link"
};
const _hoisted_27 = {
  class: "text-error py-2"
};
const _hoisted_28 = {
  class: "text-error py-2"
};
const _hoisted_29 = {
  class: "w-4/12 pl-6"
};
import { reactive, computed, onMounted } from 'vue';
import Loader from '@/components/Loader.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTextField from '@/components/LlTextField.vue';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import IntegrationRequiredModal from '@/components/modals/IntegrationRequiredModal.vue';
import { useInvoiceEmailStore } from '@/modules/settings/company/InvoiceEmail/useInvoiceEmailStore.js';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import { getShortDateString, isValidSingleEmail, isValidEmail } from '@/services/utils';
import LlSwitch from '@/components/LlSwitch.vue';
import { useSupportChat } from '@/composables/useSupportChat';
import RouteService from '@/services/RouteService';
import EmailPreviewDialog from './EmailPreviewDialog.vue';
import MissingSenderEmailModel from '@/modules/settings/company/InvoiceEmailActivity/MissingSenderEmailModel.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { storeToRefs } from 'pinia';
export default {
  __name: 'EmailCustomizationModal',
  props: {
    rootScope: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    clientMatterManager: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      getSupportUrl
    } = useSupportChat();
    const props = __props;
    const emailCustomizationModelState = reactive({
      loading: false,
      error: null,
      success: null,
      invoice: [],
      form: {
        email: '',
        bccs: '',
        ccs: '',
        subject: '',
        body: '',
        fromEmail: '',
        cCSender: true
      },
      invoiceId: '',
      previewDialog: false,
      defaultModules: [],
      invoiceList: [],
      hasExpenseAttachments: true,
      hasTrustAttachment: true,
      cancelConfidoLegalModel: false,
      showErrorOnFullBalanceLink: false,
      showErrorOnInvoicePaymentLink: false,
      enabledFullBalanceLink: false,
      enableInvoicePaymentLink: false,
      showEmailNotEnabledModal: false,
      accountSummary: '',
      testEmailState: {},
      additionalEmailsCount: 0,
      groupInvoiceEmail: false,
      disableOnMultiInvoice: true,
      // Email validation state
      emailValidation: {
        hasInvalidEmail: false,
        errorMessage: ''
      },
      ccValidation: {
        hasInvalidEmail: false,
        errorMessage: ''
      },
      bccValidation: {
        hasInvalidEmail: false,
        errorMessage: ''
      }
    });
    const subjectMissing = computed(() => emailCustomizationModelState.form.subject === null || emailCustomizationModelState.form.subject.length === 0);
    const sendButtonDisabled = computed(() => subjectMissing.value || emailCustomizationModelState.emailValidation.hasInvalidEmail || emailCustomizationModelState.ccValidation.hasInvalidEmail || emailCustomizationModelState.bccValidation.hasInvalidEmail);
    const email = {};
    const invoiceEmailStore = useInvoiceEmailStore();
    const routeService = new RouteService(props);
    const {
      getMe
    } = useMeStore();
    const {
      loadMyCompany
    } = useCompanyStore();
    const {
      features,
      access,
      settings
    } = storeToRefs(useMeStore());
    const {
      companySettings,
      name
    } = storeToRefs(useCompanyStore());
    const invoiceEditorStore = useInvoiceEditorStore();
    const {
      handleError
    } = useSnackbarHandler();
    invoiceEmailStore.alerts = props.alerts;
    onMounted(async () => {
      emailCustomizationModelState.loading = true;
      emailCustomizationModelState.invoiceId = routeService.params().id;
      emailCustomizationModelState.invoiceList = routeService.params().invoices;
      emailCustomizationModelState.groupInvoiceEmail = routeService.params().option?.actions?.groupInvoiceEmail;
      await Promise.all([getMe(), loadMyCompany(), getInvoiceDeliverySettings()]);
      if (emailCustomizationModelState.invoiceId) {
        emailCustomizationModelState.invoice = await invoiceEditorStore.getInvoice({
          id: emailCustomizationModelState.invoiceId
        });
        emailCustomizationModelState.hasExpenseAttachments = emailCustomizationModelState.invoice.hasExpenseAttachments;
        emailCustomizationModelState.hasTrustAttachment = emailCustomizationModelState.invoice.attachments?.trustStatement;
        emailCustomizationModelState.disableOnMultiInvoice = false;
        await getQBemailinfo();
      } else if (emailCustomizationModelState.groupInvoiceEmail) {
        emailCustomizationModelState.disableOnMultiInvoice = false;
        email.ccs = getUniquePrimaryEmails();
        email.email = routeService.params().clientInfo.address.email;
        email.bccs = '';
      } else {
        email.bccs = 'Multiple invoices selected';
        email.ccs = 'Multiple invoices selected';
        email.email = 'Multiple invoices selected';
      }
      email.cCSender = settings.value.ccMeOnInvoicesByDefault;
      resetForm();

      // inject placeholder values
      if (emailCustomizationModelState.invoiceId) {
        await getAccountSummary();
        emailCustomizationModelState.form.body = await injectTemplateValues(emailCustomizationModelState.form.body);
        emailCustomizationModelState.form.subject = await injectTemplateValues(emailCustomizationModelState.form.subject);
      } else if (emailCustomizationModelState.groupInvoiceEmail) {
        emailCustomizationModelState.form.body = await injectTemplateValuesMultiple(emailCustomizationModelState.form.body);
        emailCustomizationModelState.form.subject = await injectTemplateValuesMultiple(emailCustomizationModelState.form.subject);
      }
      emailCustomizationModelState.loading = false;

      // Validate email fields if they have content on mount
      validateToEmail();
      validateCcEmail();
      validateBccEmail();
    });
    function getUniquePrimaryEmails() {
      const uniqueEmails = emailCustomizationModelState.invoiceList.reduce((accumulator, invoice) => {
        if (invoice.matter && invoice.matter.primary?.email) {
          accumulator.add(invoice.matter.primary.email);
        } else if (invoice.matters) {
          invoice.matters.forEach(matter => {
            if (matter?.primary?.email) {
              accumulator.add(matter.primary.email);
            }
          });
        }
        return accumulator;
      }, new Set());
      return Array.from(uniqueEmails).join(',');
    }
    async function injectTemplateValuesMultiple(original) {
      original = original || '';
      const client = await props.clientMatterManager.getClient(emailCustomizationModelState.invoiceList[0].client.id);
      return original.replace(/{client_name}/g, client?.name || '{client_name}').replace(/{client_first_name}/g, client?.contact?.first || '{client_first_name}').replace(/{client_last_name}/g, client?.contact?.last || '{client_last_name}')

      // These values will not be available for multiple invoices
      .replace(/{invoice_date}/g, '').replace(/{invoice_number}/g, '').replace(/{date_due}/g, '').replace(/{due_date}/g, '').replace(/{amount_due}/g, '').replace(/{trust_amount_due}/g, '').replace(/{matter_name}/g, '');
    }
    async function injectTemplateValues(original) {
      original = original || '';
      let responsiblesString = '';
      const client = await props.clientMatterManager.getClient(emailCustomizationModelState.invoice.client.id);
      if (client && (original.indexOf('{responsible}') > -1 || original.indexOf('{responsible_attorney}') > -1)) {
        let matters = [];
        if (emailCustomizationModelState.invoice.matter) {
          matters.push(emailCustomizationModelState.invoice.matter);
        } else {
          const matterList = await props.clientMatterManager.listMatters({
            scope: 'all'
          });
          matters = matterList.filter(m => m.client.id === emailCustomizationModelState.invoice.client.id);
        }
        const responsibles = matters?.map(m => m.primary.name) || '';
        responsiblesString = responsibles.length > 1 ? responsibles.join(', ') : responsibles[0] || '';
      }
      const clientFirstName = client?.contact?.first;
      return original.replace(/{client_name}/g, client?.name || '{client_name}').replace(/{invoice_number}/g, emailCustomizationModelState?.invoice?.reference || '{invoice_number}').replace(/ {client_first_name}/g, clientFirstName ? ` ${clientFirstName}` : '').replace(/{client_first_name}/g, client?.contact?.first || '{client_first_name}').replace(/{client_last_name}/g, client?.contact?.last || '{client_last_name}').replace(/{firm_name}/g, name.value || '{firm_name}').replace(/{date_due}/g, getShortDateString(emailCustomizationModelState?.invoice?.due) || '{date_due}').replace(/{amount_due}/g, (emailCustomizationModelState.accountSummary.toPay || 0).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      })).replace(/{matter_name}/g, emailCustomizationModelState?.invoice?.matter?.name || '').replace(/{responsible_attorney}/g, responsiblesString).replace(/{responsible}/g, responsiblesString);
    }
    async function getInvoiceDeliverySettings() {
      const invoiceDeliverySettings = await invoiceEmailStore.getInvoiceDeliverySettings();
      const {
        subject,
        body,
        enabled,
        fromEmail,
        fromName,
        modules,
        logoUrl,
        buttonColor
      } = invoiceDeliverySettings;
      emailCustomizationModelState.defaultModules = modules;
      emailCustomizationModelState.modules = modules?.filter(x => x.id == 1 || x.id == 8)?.sort((a, b) => a.name.localeCompare(b.name));
      emailCustomizationModelState.modules.forEach(module => {
        if (module.id === 1) {
          emailCustomizationModelState.enabledFullBalanceLink = module.enabled;
        } else if (module.id === 8) {
          emailCustomizationModelState.enableInvoicePaymentLink = module.enabled;
        }
      });
      emailCustomizationModelState.enabled = enabled;
      email.fromEmail = fromEmail;
      email.fromName = fromName;
      email.body = body;
      email.subject = subject;
      email.logoUrl = logoUrl;
      email.buttonColor = buttonColor;
    }
    async function getQBemailinfo() {
      const qbEmailInfo = await invoiceEmailStore.getQBemailinfo(emailCustomizationModelState.invoice.accounting.id);
      email.bccs = qbEmailInfo.bccs;
      email.ccs = qbEmailInfo.ccs;
      email.email = qbEmailInfo.email;
    }
    async function getAccountSummary() {
      const accountSummary = await invoiceEmailStore.getAccountSummary(emailCustomizationModelState.invoice.id);
      emailCustomizationModelState.accountSummary = accountSummary;
    }
    const sendEmail = async () => {
      const modulesIds = getEnabledModuleIds();
      handleCloseButton({
        modules: modulesIds,
        body: emailCustomizationModelState.form.body,
        subject: emailCustomizationModelState.form.subject,
        bCCs: emailCustomizationModelState.form.bccs,
        cCs: emailCustomizationModelState.form.ccs,
        to: emailCustomizationModelState.form.email,
        timeSheetId: emailCustomizationModelState.invoiceId,
        cCSender: emailCustomizationModelState.form.cCSender
      });
    };
    const sendGroupInvoiceEmail = async () => {
      const modulesIds = getEnabledModuleIds(true);
      props.rootScope.sendGroupInvoiceEmail({
        to: emailCustomizationModelState.form.email,
        ccs: emailCustomizationModelState.form.ccs,
        bccs: emailCustomizationModelState.form.bccs,
        subject: emailCustomizationModelState.form.subject,
        body: emailCustomizationModelState.form.body,
        cCSender: emailCustomizationModelState.form.cCSender,
        clientInfo: routeService.params().clientInfo,
        modules: modulesIds
      });
      routeService.go('^');
    };
    const getEnabledModuleIds = removeLinks => {
      let enabledModules = emailCustomizationModelState.modules.filter(x => x.enabled).map(x => x.id).concat(emailCustomizationModelState.defaultModules.filter(x => x.enabled && emailCustomizationModelState.modules.indexOf(x) === -1).map(x => x.id));
      if (removeLinks) {
        enabledModules = enabledModules.filter(id => id !== 1 && id !== 8);
      }
      return enabledModules;
    };
    const prepareToSend = () => {
      if (!email.fromEmail) {
        emailCustomizationModelState.showEmailNotEnabledModal = true;
        return;
      }
      if (routeService.params().option?.actions?.groupInvoiceEmail) {
        sendGroupInvoiceEmail();
        return;
      }
      if (companySettings.value.gravity?.enabled) {
        sendEmail();
      } else {
        if (emailCustomizationModelState.enabledFullBalanceLink || emailCustomizationModelState.enableInvoicePaymentLink) {
          emailCustomizationModelState.showGravityModal = true;
          return;
        } else {
          sendWithoutPaymentLink();
        }
      }
    };
    const ai = async () => {
      emailCustomizationModelState.loadingAI = true;
      const response = await invoiceEmailStore.getInvoiceEmail({
        id: emailCustomizationModelState.invoiceId
      });
      const email = response.choices[0].message.content;
      // split off the subject if emails starts with line "Subject: "
      const emailParts = email.split('\n');
      if (emailParts[0].startsWith('Subject: ')) {
        emailCustomizationModelState.form.subject = emailParts[0].replace('Subject: ', '');
        emailCustomizationModelState.form.body = emailParts.slice(1).join('\n');
      } else {
        emailCustomizationModelState.form.body = email;
      }
      emailCustomizationModelState.loadingAI = false;
    };
    const sendWithoutPaymentLink = async () => {
      emailCustomizationModelState.showGravityModal = false;
      const modulesIds = getEnabledModuleIds();
      handleCloseButton({
        modules: modulesIds,
        body: emailCustomizationModelState.form.body,
        subject: emailCustomizationModelState.form.subject,
        bCCs: emailCustomizationModelState.form.bccs,
        cCs: emailCustomizationModelState.form.ccs,
        to: emailCustomizationModelState.form.email,
        timeSheetId: emailCustomizationModelState.invoiceId
      });
    };
    const resetForm = () => {
      emailCustomizationModelState.form = JSON.parse(JSON.stringify(email));
    };
    const cancelConfidoLegalModel = () => {
      emailCustomizationModelState.showGravityModal = false;
      emailCustomizationModelState.cancelConfidoLegalModel = true;
      emailCustomizationModelState.showErrorOnFullBalanceLink = true;
      emailCustomizationModelState.showErrorOnInvoicePaymentLink = true;
    };
    const updateSenderEmail = senderEmail => {
      emailCustomizationModelState.form.fromEmail = senderEmail;
      email.fromEmail = senderEmail;
    };
    async function selectItemsToggle(module) {
      module.enabled = !module.enabled;
      if (module.id === 1) {
        emailCustomizationModelState.enabledFullBalanceLink = module.enabled;
        if (emailCustomizationModelState.cancelConfidoLegalModel) {
          emailCustomizationModelState.showErrorOnFullBalanceLink = false;
        }
      }
      if (module.id === 8) {
        emailCustomizationModelState.enableInvoicePaymentLink = module.enabled;
        if (emailCustomizationModelState.cancelConfidoLegalModel) {
          emailCustomizationModelState.showErrorOnInvoicePaymentLink = false;
        }
      }
    }
    function handleCloseButton(emailBody) {
      if (!emailBody && emailCustomizationModelState.testEmailState.isTestEmail) {
        routeService.go('^');
        return;
      }
      if (emailCustomizationModelState.testEmailState.isTestEmail) {
        invoiceEmailStore.testEmail({
          to: emailCustomizationModelState.testEmailState.testEmailAddress,
          body: emailBody,
          timeSheetId: emailCustomizationModelState.invoiceId ? emailBody?.timeSheetId : routeService?.params()?.invoices[0]?.id
        });
        return;
      }
      if (emailBody) {
        if (!emailCustomizationModelState.invoiceId) {
          emailBody = {
            modules: emailBody.modules,
            body: emailBody.body,
            subject: emailBody.subject,
            cCSender: emailBody.cCSender,
            bulk: true
          };
        }
        props.rootScope.processCustomizedEmail(routeService.params().invoice, routeService.params().option, emailBody);
      }
      routeService.go('^');
    }
    function goToConfidoIntegration() {
      routeService.go('settings.company.integrations');
      emailCustomizationModelState.showGravityModal = false;
    }
    function goToEmailSettings() {
      routeService.go('settings.company.invoiceEmail');
      emailCustomizationModelState.showEmailNotEnabledModal = false;
    }
    function openSupportLink() {
      window.open(getSupportUrl('emailServiceSetup'), '_blank');
    }
    const validateToEmail = () => {
      // Skip validation if multiple invoices are selected
      if (emailCustomizationModelState.disableOnMultiInvoice) {
        return;
      }
      const emailValue = emailCustomizationModelState.form.email;

      // Reset validation state
      emailCustomizationModelState.emailValidation.hasInvalidEmail = false;
      emailCustomizationModelState.emailValidation.errorMessage = '';

      // Use isValidEmail function which handles multiple comma-separated emails
      const isValid = isValidEmail(emailValue);
      if (!isValid || !emailValue || emailValue.trim() === '') {
        emailCustomizationModelState.emailValidation.hasInvalidEmail = true;
        emailCustomizationModelState.emailValidation.errorMessage = 'Please enter a valid email address.';
      }
    };
    const validateCcEmail = () => {
      // Skip validation if multiple invoices are selected
      if (emailCustomizationModelState.disableOnMultiInvoice) {
        return;
      }
      const emailValue = emailCustomizationModelState.form.ccs;

      // Reset validation state
      emailCustomizationModelState.ccValidation.hasInvalidEmail = false;
      emailCustomizationModelState.ccValidation.errorMessage = '';

      // If empty, no validation needed for Cc (optional field)
      if (!emailValue || emailValue.trim() === '') {
        return;
      }

      // Parse individual emails and check each one
      const emails = emailValue.split(/[\s,]+/).filter(Boolean);
      const invalidEmails = emails.filter(email => !isValidSingleEmail(email.trim()));
      if (invalidEmails.length > 0) {
        emailCustomizationModelState.ccValidation.hasInvalidEmail = true;
        if (invalidEmails.length === 1) {
          emailCustomizationModelState.ccValidation.errorMessage = `Invalid email: ${invalidEmails[0]}`;
        } else {
          emailCustomizationModelState.ccValidation.errorMessage = `Invalid emails: ${invalidEmails.join(', ')}`;
        }
      }
    };
    const validateBccEmail = () => {
      // Skip validation if multiple invoices are selected
      if (emailCustomizationModelState.disableOnMultiInvoice) {
        return;
      }
      const emailValue = emailCustomizationModelState.form.bccs;

      // Reset validation state
      emailCustomizationModelState.bccValidation.hasInvalidEmail = false;
      emailCustomizationModelState.bccValidation.errorMessage = '';

      // If empty, no validation needed for Bcc (optional field)
      if (!emailValue || emailValue.trim() === '') {
        return;
      }

      // Parse individual emails and check each one
      const emails = emailValue.split(/[\s,]+/).filter(Boolean);
      const invalidEmails = emails.filter(email => !isValidSingleEmail(email.trim()));
      if (invalidEmails.length > 0) {
        emailCustomizationModelState.bccValidation.hasInvalidEmail = true;
        if (invalidEmails.length === 1) {
          emailCustomizationModelState.bccValidation.errorMessage = `Invalid email: ${invalidEmails[0]}`;
        } else {
          emailCustomizationModelState.bccValidation.errorMessage = `Invalid emails: ${invalidEmails.join(', ')}`;
        }
      }
    };
    const validateSingleEmail = () => {
      if (!emailCustomizationModelState.form.email) return false;

      // Split the string by space and comma, filter out empty strings
      const emails = emailCustomizationModelState.form.email.split(/[\s,]+/).filter(Boolean);
      if (emails.length > 1) {
        // Filter out invalid emails and only count valid ones
        const validEmails = emails.filter(email => isValidSingleEmail(email.trim()));
        if (validEmails.length > 1) {
          // More than one valid email found, update the count
          emailCustomizationModelState.additionalEmailsCount = validEmails.length - 1; // Subtract one for the email allowed in the "To" field
          return true;
        }
      }
      return false;
    };
    const goToEmailSettingsPage = () => {
      routeService.go('settings.company.invoiceEmail');
    };
    const clicked = () => {
      handleError('Payment links are not available for invoice groups.');
    };
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_textarea = _resolveComponent("v-textarea");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_container = _resolveComponent("v-container");
      const _component_v_card_text = _resolveComponent("v-card-text");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SnackbarComponent, {
        ref: "snackbar"
      }, null, 512), _createElementVNode("div", _hoisted_2, [emailCustomizationModelState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Email',
        class: "my-16 px-6"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_v_dialog, {
        modelValue: emailCustomizationModelState.showGravityModal,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => emailCustomizationModelState.showGravityModal = $event),
        width: "700"
      }, {
        default: _withCtx(() => [_createVNode(IntegrationRequiredModal, {
          title: "Payments Partner Confido Legal",
          body: "You need an account with our payments partner Confido Legal to send emails with payment links.",
          onCancel: cancelConfidoLegalModel,
          showSupportLink: false,
          goAndSetupText: "Learn more and get set up",
          secondaryAction: "Send without payment link",
          onGoToSetup: _cache[0] || (_cache[0] = $event => goToConfidoIntegration()),
          onSecondaryAction: _cache[1] || (_cache[1] = $event => sendWithoutPaymentLink())
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_v_dialog, {
        modelValue: emailCustomizationModelState.showEmailNotEnabledModal,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => emailCustomizationModelState.showEmailNotEnabledModal = $event),
        width: "700"
      }, {
        default: _withCtx(() => [_createVNode(IntegrationRequiredModal, {
          title: "Sender Info Not Configured",
          body: _unref(access)?.setup ? 'You need to add a firm reply-to email address to send an email.' : 'You need to add a firm reply-to email address to send an email. Ask a user with access to firm settings to update your email settings now.',
          onCancel: _cache[3] || (_cache[3] = $event => emailCustomizationModelState.showEmailNotEnabledModal = false),
          showSupportLink: _unref(access)?.setup ? false : true,
          supportText: "Find Out More",
          showGoAndSetup: _unref(access)?.setup ? true : false,
          goAndSetupText: "Add Sender Email Now",
          onGoToSetup: _cache[4] || (_cache[4] = $event => goToEmailSettings()),
          onGoToSupportLink: _cache[5] || (_cache[5] = $event => openSupportLink())
        }, null, 8, ["body", "showSupportLink", "showGoAndSetup"])]),
        _: 1
      }, 8, ["modelValue"]), !emailCustomizationModelState.form?.fromEmail ? (_openBlock(), _createBlock(MissingSenderEmailModel, {
        key: 0,
        state: props.state,
        stateParams: __props.stateParams,
        emailCustomizationState: emailCustomizationModelState,
        alerts: __props.alerts,
        onUpdateSenderEmail: updateSenderEmail
      }, null, 8, ["state", "stateParams", "emailCustomizationState", "alerts"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(_component_v_dialog, {
        modelValue: emailCustomizationModelState.previewDialog,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => emailCustomizationModelState.previewDialog = $event),
        width: "1000"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, {
          title: "Preview"
        }, {
          append: _withCtx(() => [_createVNode(_component_v_icon, {
            onClick: _cache[7] || (_cache[7] = $event => emailCustomizationModelState.previewDialog = false)
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode("mdi-close", -1)]))]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(EmailPreviewDialog, {
            state: emailCustomizationModelState.form,
            dialog: true,
            hasExpenseAttachments: emailCustomizationModelState.hasExpenseAttachments,
            hasTrustAttachment: emailCustomizationModelState.hasTrustAttachment,
            modules: emailCustomizationModelState.defaultModules,
            accountSummary: emailCustomizationModelState.accountSummary,
            invoiceList: emailCustomizationModelState.invoiceList,
            testEmailState: emailCustomizationModelState.testEmailState,
            leanLawAuth: props.leanLawAuth,
            onTestEmail: _cache[8] || (_cache[8] = $event => {
              prepareToSend();
              emailCustomizationModelState.previewDialog = false;
            })
          }, null, 8, ["state", "hasExpenseAttachments", "hasTrustAttachment", "modules", "accountSummary", "invoiceList", "testEmailState", "leanLawAuth"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_component_v_card, {
        title: "Email",
        class: "px-4 pt-4"
      }, {
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          onClick: _cache[10] || (_cache[10] = $event => handleCloseButton())
        }, {
          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [emailCustomizationModelState.invoiceList?.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(emailCustomizationModelState.invoiceList?.length) + " invoices selected. ", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_unref(access)?.setup ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 0,
            class: "mr-2",
            variant: "flat",
            "prepend-icon": "mdi-cog",
            onClick: _cache[11] || (_cache[11] = _withModifiers($event => goToEmailSettingsPage(), ["prevent"]))
          }, {
            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode(" Email Settings", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(LlSecondaryButton, {
            color: "primary",
            variant: "outlined",
            "prepend-icon": "mdi-arrow-down-left",
            onClick: _cache[12] || (_cache[12] = _withModifiers($event => resetForm(), ["prevent"]))
          }, {
            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode(" Revert to template", -1)]))]),
            _: 1
          })])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[37] || (_cache[37] = _createElementVNode("label", {
            class: "text-base"
          }, "To: ", -1)), _createVNode(LlTextField, {
            id: "at-to-field",
            "data-cy": "to-field",
            type: "text",
            density: "compact",
            modelValue: emailCustomizationModelState.form.email,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => emailCustomizationModelState.form.email = $event),
            disabled: emailCustomizationModelState.disableOnMultiInvoice,
            variant: "outlined",
            onChange: validateToEmail,
            onBlur: validateToEmail
          }, null, 8, ["modelValue", "disabled"]), _withDirectives(_createElementVNode("div", _hoisted_9, [_cache[29] || (_cache[29] = _createElementVNode("span", {
            class: "text-error px-2"
          }, [_createElementVNode("i", {
            class: "fa fa-exclamation-circle"
          })], -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(emailCustomizationModelState.emailValidation.errorMessage), 1)], 512), [[_vShow, emailCustomizationModelState.emailValidation.hasInvalidEmail]]), _withDirectives(_createElementVNode("div", _hoisted_11, [_cache[30] || (_cache[30] = _createElementVNode("span", {
            class: "warning px-2"
          }, [_createElementVNode("i", {
            class: "fa fa-warning"
          })], -1)), _createElementVNode("span", null, _toDisplayString(emailCustomizationModelState.additionalEmailsCount) + " " + _toDisplayString(emailCustomizationModelState.additionalEmailsCount > 1 ? 'addresses' : 'address') + " will be moved to \"Cc\" because only one email is allowed in the \"To\" field. ", 1)], 512), [[_vShow, validateSingleEmail()]]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[32] || (_cache[32] = _createElementVNode("label", {
            class: "text-base"
          }, "Cc: ", -1)), _createVNode(LlTextField, {
            class: "",
            "data-cy": "email-cc",
            type: "text",
            density: "compact",
            modelValue: emailCustomizationModelState.form.ccs,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => emailCustomizationModelState.form.ccs = $event),
            disabled: emailCustomizationModelState.disableOnMultiInvoice,
            variant: "outlined",
            "hide-details": "true",
            onChange: validateCcEmail,
            onBlur: validateCcEmail
          }, null, 8, ["modelValue", "disabled"]), _withDirectives(_createElementVNode("div", _hoisted_14, [_cache[31] || (_cache[31] = _createElementVNode("span", {
            class: "text-error px-1 text-sm"
          }, [_createElementVNode("i", {
            class: "fa fa-exclamation-circle"
          })], -1)), _createElementVNode("span", _hoisted_15, _toDisplayString(emailCustomizationModelState.ccValidation.errorMessage), 1)], 512), [[_vShow, emailCustomizationModelState.ccValidation.hasInvalidEmail]])]), _createElementVNode("div", _hoisted_16, [_cache[34] || (_cache[34] = _createElementVNode("label", {
            class: "text-base"
          }, "Bcc: ", -1)), _createVNode(LlTextField, {
            class: "",
            "data-cy": "email-bcc",
            type: "text",
            density: "compact",
            modelValue: emailCustomizationModelState.form.bccs,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => emailCustomizationModelState.form.bccs = $event),
            disabled: emailCustomizationModelState.disableOnMultiInvoice,
            variant: "outlined",
            "hide-details": "true",
            onChange: validateBccEmail,
            onBlur: validateBccEmail
          }, null, 8, ["modelValue", "disabled"]), _withDirectives(_createElementVNode("div", _hoisted_17, [_cache[33] || (_cache[33] = _createElementVNode("span", {
            class: "text-error px-1 text-sm"
          }, [_createElementVNode("i", {
            class: "fa fa-exclamation-circle"
          })], -1)), _createElementVNode("span", _hoisted_18, _toDisplayString(emailCustomizationModelState.bccValidation.errorMessage), 1)], 512), [[_vShow, emailCustomizationModelState.bccValidation.hasInvalidEmail]])])]), _createElementVNode("div", _hoisted_19, [_createVNode(LlCheckbox, {
            label: "Send a copy to myself",
            modelValue: emailCustomizationModelState.form.cCSender,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => emailCustomizationModelState.form.cCSender = $event)
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_20, [_cache[35] || (_cache[35] = _createElementVNode("label", {
            class: "text-base"
          }, "Subject: ", -1)), _createVNode(LlTextField, {
            class: "",
            "data-cy": "email-subject",
            type: "text",
            density: "compact",
            modelValue: emailCustomizationModelState.form.subject,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => emailCustomizationModelState.form.subject = $event),
            variant: "outlined",
            error: subjectMissing.value,
            "error-messages": subjectMissing.value ? 'A subject is required' : ''
          }, null, 8, ["modelValue", "error", "error-messages"])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_v_textarea, {
            modelValue: emailCustomizationModelState.form.body,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => emailCustomizationModelState.form.body = $event),
            "data-cy": "email-body",
            "auto-grow": "",
            variant: "outlined",
            density: "compact",
            rows: "4"
          }, null, 8, ["modelValue"]), _unref(features)?.aiemail ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 0,
            variant: "flat",
            "append-icon": "mdi-auto-fix",
            onClick: _cache[19] || (_cache[19] = _withModifiers($event => ai(), ["prevent"])),
            disabled: emailCustomizationModelState.loadingAI
          }, {
            default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode("AI", -1)]))]),
            _: 1
          }, 8, ["disabled"])) : _createCommentVNode("", true)]), emailCustomizationModelState.groupInvoiceEmail ? (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emailCustomizationModelState.modules, (moduleState, id) => {
            return _openBlock(), _createElementBlock("div", {
              class: "p-2",
              key: id
            }, [_createElementVNode("div", _hoisted_23, [_createVNode(LlSwitch, {
              modelValue: moduleState.enabled,
              "onUpdate:modelValue": $event => moduleState.enabled = $event,
              label: moduleState.name,
              disabled: true,
              onClick: _cache[20] || (_cache[20] = $event => clicked())
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])])]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emailCustomizationModelState.modules, (moduleState, id) => {
            return _openBlock(), _createElementBlock("div", {
              class: "p-2",
              key: id
            }, [_createElementVNode("div", {
              class: _normalizeClass(["flex flex-row px-2", {
                'bg-[rgba(var(--v-theme-error),0.08)]': (emailCustomizationModelState.showErrorOnFullBalanceLink || emailCustomizationModelState.showErrorOnInvoicePaymentLink) && (moduleState.id == 1 || moduleState.id == 8) && moduleState.enabled
              }])
            }, [_createVNode(LlSwitch, {
              "model-value": moduleState.enabled,
              "onUpdate:modelValue": $event => selectItemsToggle(moduleState)
            }, null, 8, ["model-value", "onUpdate:modelValue"]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(moduleState.name), 1), _withDirectives(_createElementVNode("div", _hoisted_27, " Toggle off and send without payment link ", 512), [[_vShow, emailCustomizationModelState.showErrorOnFullBalanceLink && moduleState.id == 1 && moduleState.enabled]]), _withDirectives(_createElementVNode("div", _hoisted_28, " Toggle off and send without payment link ", 512), [[_vShow, emailCustomizationModelState.showErrorOnInvoicePaymentLink && moduleState.id == 8 && moduleState.enabled]])])], 2)]);
          }), 128))]))]), _createElementVNode("div", _hoisted_29, [_createElementVNode("label", {
            class: "text-base pb-2 underline text-center",
            "data-cy": "previewAndTestLink",
            onClick: _cache[21] || (_cache[21] = _withModifiers($event => emailCustomizationModelState.previewDialog = true, ["prevent"]))
          }, "Preview and send test Email"), _createElementVNode("div", null, [_createVNode(EmailPreviewDialog, {
            state: emailCustomizationModelState.form,
            modules: emailCustomizationModelState.defaultModules,
            hasExpenseAttachments: emailCustomizationModelState.hasExpenseAttachments,
            accountSummary: emailCustomizationModelState.accountSummary,
            hasTrustAttachment: emailCustomizationModelState.hasTrustAttachment,
            leanLawAuth: props.leanLawAuth,
            onOpenPreview: _cache[22] || (_cache[22] = $event => emailCustomizationModelState.previewDialog = true)
          }, null, 8, ["state", "modules", "hasExpenseAttachments", "accountSummary", "hasTrustAttachment", "leanLawAuth"])]), _cache[38] || (_cache[38] = _createElementVNode("div", {
            class: "flex pt-4"
          }, [_createElementVNode("div", {
            class: "text-gray-700"
          }, [_createElementVNode("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [_createElementVNode("path", {
            d: "M7.45 17.5C5.93333 17.5 4.64583 16.9625 3.5875 15.8875C2.52917 14.8125 2 13.5167 2 12C2 10.4833 2.52083 9.1875 3.5625 8.1125C4.60417 7.0375 5.88333 6.5 7.4 6.5H18.15C19.2167 6.5 20.125 6.87917 20.875 7.6375C21.625 8.39583 22 9.30833 22 10.375C22 11.4417 21.625 12.3542 20.875 13.1125C20.125 13.8708 19.2167 14.25 18.15 14.25H8.275C7.64167 14.25 7.10417 14.0333 6.6625 13.6C6.22083 13.1667 6 12.6333 6 12C6 11.3667 6.22917 10.8333 6.6875 10.4C7.14583 9.96667 7.69167 9.75 8.325 9.75H18.15V10.75H8.3C7.95 10.75 7.64583 10.8708 7.3875 11.1125C7.12917 11.3542 7 11.65 7 12C7 12.35 7.125 12.6458 7.375 12.8875C7.625 13.1292 7.925 13.25 8.275 13.25H18.15C18.95 13.25 19.625 12.9708 20.175 12.4125C20.725 11.8542 21 11.175 21 10.375C21 9.575 20.725 8.89583 20.175 8.3375C19.625 7.77917 18.95 7.5 18.15 7.5H7.35C6.13333 7.5 5.10417 7.94167 4.2625 8.825C3.42083 9.70833 3 10.7667 3 12C3 13.25 3.42917 14.3125 4.2875 15.1875C5.14583 16.0625 6.19167 16.5 7.425 16.5H18.15V17.5H7.45Z",
            fill: "#747474"
          })])]), _createElementVNode("div", {
            class: "pl-2 text-gray-600 italic"
          }, "Attachments:")], -1)), _cache[39] || (_cache[39] = _createElementVNode("div", {
            class: "text-gray-600 italic"
          }, " Manage attachments coming soon! ", -1))])]), _createElementVNode("div", null, [_createVNode(_component_v_container, null, {
            default: _withCtx(() => [_createVNode(_component_v_row, {
              justify: "end",
              align: "end"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "auto"
              }, {
                default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                  onClick: _cache[23] || (_cache[23] = _withModifiers($event => handleCloseButton(), ["prevent"]))
                }, {
                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createTextVNode(" Cancel ", -1)]))]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "auto",
                class: "at-send-email",
                title: subjectMissing.value ? 'A subject is required' : emailCustomizationModelState.emailValidation.hasInvalidEmail ? 'Please fix invalid email addresses in To field' : emailCustomizationModelState.ccValidation.hasInvalidEmail ? 'Please fix invalid email addresses in Cc field' : emailCustomizationModelState.bccValidation.hasInvalidEmail ? 'Please fix invalid email addresses in Bcc field' : ''
              }, {
                default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                  variant: "flat",
                  color: "primary",
                  id: "at-send-email",
                  "data-cy": "send-email",
                  disabled: sendButtonDisabled.value,
                  onClick: _cache[24] || (_cache[24] = _withModifiers($event => prepareToSend(), ["prevent"]))
                }, {
                  default: _withCtx(() => [...(_cache[41] || (_cache[41] = [_createTextVNode("Send", -1)]))]),
                  _: 1
                }, 8, ["disabled"])]),
                _: 1
              }, 8, ["title"])]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      })]))])]);
    };
  }
};